import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./sobre.css";
import fotoDupla from "../../assets/lilia-mirelly.png";
import retanguloBg from "../../assets/retangulo.png";

export default function Sobre() {
  return (
    <div className="sobre-wrapper">
      <div className="watermark-bg">LM</div>
      <div className="sobre-overlay"></div>

      <div className="container-figma">
        <section id="sobre" className="sobre-time-grid">
          <motion.div
            className="imagem-area-container"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img src={retanguloBg} className="retangulo-atras" alt="" />
            <img
              src={fotoDupla}
              className="foto-principal"
              alt="Lilia e Mirelly"
            />
          </motion.div>

          <motion.div
            className="texto-area-container"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="titulo-time-figma">
              QUEM ESTÁ POR TRÁS DAS <span className="rosa">ESTRATÉGIAS</span>{" "}
              <br />
              QUE GERAM <span className="azul">RESULTADOS</span>
            </h2>

            <ul className="lista-beneficios">
              <li>
                <span>
                  Somos a <strong>Conecta LM</strong>, e acreditamos que marcas
                  fortes nascem de estratégia e direção.
                </span>
              </li>
              <li>
                <span>
                  Lilia lidera o <strong>desenvolvimento</strong> e a estrutura
                  tecnológica dos projetos.
                </span>
              </li>
              <li>
                <span>
                  Mirelly é responsável pelo <strong>marketing</strong> e pela
                  construção da presença digital das marcas.
                </span>
              </li>
              <li>
                <span>
                  Trabalhamos juntas para <strong>transformar ideias</strong> em
                  posicionamento estratégico.
                </span>
              </li>
              <li>
                <span>
                  Nosso propósito é{" "}
                  <strong>conectar, posicionar e transformar</strong> negócios
                  no digital.
                </span>
              </li>
              <li>
                <span>
                  Acreditamos que marcas bem posicionadas não apenas aparecem,{" "}
                  <strong>elas são lembradas e escolhidas.</strong>
                </span>
              </li>
            </ul>
          </motion.div>
        </section>

        <section className="etapas-section">
          <h2 className="titulo-etapas-figma">
            COMO PODEMOS TRANSFORMAR A <span>SUA MARCA</span>
          </h2>

          {/* NOVO: Subtítulo do Método ÁPICE */}
          <p className="subtitulo-metodo-apice">
            Esse é o nosso Método ÁPICE em ação
          </p>

          <div className="etapas-grid-layout">
            {[
              {
                e: "A",
                t: "ANÁLISE",
                p: "Entendemos sua marca, seu público e onde você quer chegar.",
              },
              {
                e: "P",
                t: "PLANEJAMENTO",
                p: "Traçamos o caminho estratégico certo antes de qualquer execução.",
              },
              {
                e: "I",
                t: "INTEGRAÇÃO",
                p: "Unimos estrutura, tecnologia e comunicação em um só sistema.",
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                className="card-etapa"
                whileHover={{
                  scale: 1.05,
                  rotateY: 15,
                  backgroundColor: "#85c3ce",
                }}
                transition={{ duration: 0.3 }}
              >
                <span className="etapa-tag">{item.e}</span>
                <h3>{item.t}</h3>
                <p>{item.p}</p>
              </motion.div>
            ))}

            <motion.div
              className="card-etapa card-4"
              whileHover={{
                scale: 1.05,
                rotateY: 15,
                backgroundColor: "#85c3ce",
              }}
            >
              <span className="etapa-tag">C</span>
              <h3>CONVERSÃO</h3>
              <p>Transformamos estratégia e conteúdo em vendas reais.</p>
            </motion.div>

            <motion.div
              className="card-etapa card-5"
              whileHover={{
                scale: 1.05,
                rotateY: 15,
                backgroundColor: "#85c3ce",
              }}
            >
              <span className="etapa-tag">E</span>
              <h3>EXPANSÃO</h3>
              <p>Escalamos os resultados de forma sustentável.</p>
            </motion.div>
          </div>

          {/* NOVO: Link para o Método ÁPICE completo */}
          <div className="link-metodo-container">
            <Link to="/metodo-apice" className="link-ver-metodo">
              Ver o Método ÁPICE completo →
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
